import { render, staticRenderFns } from "./template_edit.vue?vue&type=template&id=40f2f1b8&scoped=true"
import script from "./template_edit.vue?vue&type=script&lang=ts"
export * from "./template_edit.vue?vue&type=script&lang=ts"
import style0 from "./template_edit.vue?vue&type=style&index=0&id=40f2f1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2f1b8",
  null
  
)

export default component.exports